export default __webpack_public_path__ + "static/media/smile-3.edbcf658.svg";